import { ISMT_DeThiIn_Vm } from "../../../../model/respone/de-thi/de-thi-in/ISMT_DeThiIn_Vm";
import { IDeThiInActionTypes } from "../../../action-types/de-thi/de-thi-in/IDeThiInActions";
import { IDeThiInReducer } from "../../../reducer-model/de-thi/de-thi-in/IDeThiInReducer";
import { eReducerStatusBase } from "../../../reducer-model/eReducerStatusBase";

const iniState: IDeThiInReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  deThiInEditing: {} as ISMT_DeThiIn_Vm,
  deThiIns: [],
  request: {} as any,
};

export const deThiInReducer = (
  state: IDeThiInReducer = iniState,
  action: IDeThiInActionTypes
): IDeThiInReducer => {
  switch (action.type) {
    case "DE_THI_IN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        deThiIns: [],
      };
    case "DE_THI_IN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        deThiIns: action.payload,
      };
    case "DE_THI_IN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DE_THI_IN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DE_THI_IN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DE_THI_IN_SAVE_AND_CONTINUE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "DE_THI_IN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DE_THI_IN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DE_THI_IN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_IN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "DE_THI_IN_DELETE_MULTIPLE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_IN_DELETE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "DE_THI_IN_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "DE_THI_IN_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_IN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        deThiInEditing: action.payload,
      };
    case "DE_THI_IN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        deThiInEditing: undefined,
      };
    case "DE_THI_IN_SHOW_VIEW_FILE_MODAL":
      return {
        ...state,
        deThiInViewFile: action.payload,
      };
    case "DE_THI_IN_PROGRESS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DE_THI_IN_PROGRESS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_IN_PROGRESS_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DE_THI_IN_CHANGE_SU_DUNG_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DE_THI_IN_CHANGE_SU_DUNG_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_IN_CHANGE_SU_DUNG_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    default:
      return state;
  }
};
